import { ca } from '@cian/analytics';

export function trackOpen(): void {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_cat_save',
  });
}
